/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/conversation/action/conversationActionTypes';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {
  isBeingRepliedTo: false,
  isBeingCreated: false,
  isFetching: false,
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const handleReplyRequest = (state: Object) => ({
  ...state,
  isBeingRepliedTo: true,
});

const handleReplyFailure = (state: Object) => ({
  ...state,
  isBeingRepliedTo: false,
});

const handleReplySuccess = (state: Object) => ({
  ...state,
  isBeingRepliedTo: false,
});

const handleCreateRequest = (state: Object) => ({
  ...state,
  isBeingCreated: true,
});

const handleCreateFailure = (state: Object) => ({
  ...state,
  isBeingCreated: false,
});

const handleCreateSuccess = (state: Object) => ({
  ...state,
  isBeingCreated: false,
});

const handleFetchRequest = (state: Object) => ({
  ...state,
  isFetching: true,
});

const handleFetchSuccess = (state: Object) => ({
  ...state,
  isFetching: false,
});

const handleFetchFailure = (state: Object) => ({
  ...state,
  isFetching: false,
});

export default createReducer(initialState, {
  [types.REPLY_TO_CONVERSATION_REQUEST]: handleReplyRequest,
  [types.REPLY_TO_CONVERSATION_FAILURE]: handleReplyFailure,
  [types.REPLY_TO_CONVERSATION_SUCCESS]: handleReplySuccess,
  [types.CREATE_CONVERSATION_REQUEST]: handleCreateRequest,
  [types.CREATE_CONVERSATION_FAILURE]: handleCreateFailure,
  [types.CREATE_CONVERSATION_SUCCESS]: handleCreateSuccess,
  [types.FETCH_CONVERSATION_REQUEST]: handleFetchRequest,
  [types.FETCH_CONVERSATION_SUCCESS]: handleFetchSuccess,
  [types.FETCH_CONVERSATION_FAILURE]: handleFetchFailure,
});
